import { render } from "./Invites.vue?vue&type=template&id=92370392"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import "./Invites.vue?vue&type=style&index=0&id=92370392&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__